export default {
    BAIXA: 1,
    ALTA: 2,
}